module.exports = __webpack_public_path__ + "img/icon-2.eaa7a29e.svg";